module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Jupiter-Ascending.55d02b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Jupiter-Ascending.jpg
// module id = hOtY
// module chunks = 0